module.exports = __webpack_public_path__ + "static/img/avatar.ba28433b.png";